'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var or = {};

exports.__exports = or;
